module.exports = __webpack_public_path__ + "static/portfolio-tttr-c6563f544a019dcc76f5245dff2a13cc.png";